<template>
  <div>
    <b-modal id="add-card-modal" title="Add card" @ok="add_card">
      <b-form-group>
        <b-form-input v-model="new_card.title" placeholder="Card title"></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-textarea v-model="new_card.text" placeholder="Card text"></b-form-textarea>
      </b-form-group>
      <b-form-group>
        <b-form-input v-model="new_card.link_text" placeholder="Link text"></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input v-model="new_card.link_url" type='url' placeholder="Link URL"></b-form-input>
      </b-form-group>
    </b-modal>

    <b-row class='mt-4 cta-cards'>
      <b-col class='d-flex align-items-stretch' v-for="card in item.cards" v-bind:key="card.title">
        <b-card :title='card.title' class='px-3 py-1 cta-card'>
          <b-card-text>{{card.text}}</b-card-text>
          <b-card-text><b-link class='text-primary' :href="card.link_url" target='_blank'>{{card.link_text}}</b-link></b-card-text>
          <b-button variant='warning' @click='remove_card(card)' size="sm" style='position: absolute; right: 6px; top: 6px;'>Remove</b-button>
        </b-card>
      </b-col>
      <b-col class='d-flex align-items-stretch' v-if="item.cards.length < 3">
        <b-card title='Add a card' class='px-3 py-1 cta-card'>
          <b-card-text>Displayed under the video to link with additional content</b-card-text>
          <b-button v-b-modal.add-card-modal size='sm'>Add card</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: ['item'],
  data() {
    return {
      new_card: {
        title: '',
        text: '',
        link_text: '',
        link_url: ''
      },
    }
  },
  methods: {
    add_card(bvModalEvt) {
      if (!this.new_card.title || !this.new_card.text) {
        bvModalEvt.preventDefault()
        this.$swal({title: 'Valid text required', text: "Please enter a valid title and text", icon: 'warning'})
        return
      }

      if (this.new_card.link_text || this.new_card.link_url) {
        if (!this.new_card.link_text || !this.new_card.link_url || !this.new_card.link_url.match(/https?:\/\//i)) {
          bvModalEvt.preventDefault()
          this.$swal({title: 'Valid link required', text: "Please enter a link text and valid URL e.g. https://example.com", icon: 'warning'})
          return
        }
      }

      this.$bvModal.hide('add-card-modal')

      this.item.cards.push(this.new_card)
      this.new_card = {title: '', text: '', link_text: '', link_url: ''}
    },
    remove_card(card) {
      let cards = []
      for (let item of this.item.cards) {
        if (item.title !== card.title) {
          cards.push(item)
        }
      }

      this.item.cards = cards
    }
  }
}
</script>

<style>

.cta-card {
  width: 100%;
  min-width: 14em;
  margin-bottom: 1em;
}

.cta-card .card-title {
  font-size: 18px;
  font-weight: 600;
}

.cta-card .card-text {
  font-size: 14px;
}

</style>
